import * as defaultPaths from './requestPathDefault';
import * as newPaths from './requestPathNew';

const paths = process.env.REACT_APP_USE_NEW_REQUEST_PATH === 'true' ? newPaths : defaultPaths;

export const retrieveSubscription = paths.retrieveSubscription;
export const getSimPluginType = paths.getSimPluginType;
export const getUserSubscriptionPlans = paths.getUserSubscriptionPlans;

// 国家/地区确认（俄区订阅判定链路）：useRegionGate 守卫消费
export const getUserCountryStatus = paths.getUserCountryStatus;
export const confirmUserCountry = paths.confirmUserCountry;

// SIM 卡管理:新架构(com.xmai)与老架构(com.banya)均已提供对应服务,按 USE_NEW_REQUEST_PATH 分发
export const getSimInfo = paths.getSimInfo;
export const getSimUsage = paths.getSimUsage;
export const getSimDailyUsage = paths.getSimDailyUsage;
